<template>
	<div class="Anexo4">
		
		<h1>TABELAS RELATIVAS ÀS ÁREAS NÃO COMPUTÁVEIS</h1>

		<table id="table-1" class="quadro">
			<caption>Tabela 1 – Obras complementares</caption>
			<colgroup>
				<col class="Row-Column-1" width="32%" />
				<col class="Row-Column-2" width="17%" />
				<col class="Row-Column-2" width="17%" />
				<col class="Row-Column-2" width="17%" />
				<col class="Row-Column-2" width="17%" />
			</colgroup>
			<thead>
				<tr class="Row-Column-3">
					<td rowspan="2">
						<p>Obras Complementares </p>
					</td>
					<td colspan="2">
						<p>Poderão avançar sobre </p>
					</td>
					<td colspan="2">
						<p>Dimensões máximas </p>
					</td>
				</tr>
				<tr class="Row-Column-3">
					<td>
						<p>Passeio Público <span class="notas">(1)</span> </p>
					</td>
					<td>
						<p>Recuos LPUOS </p>
					</td>
					<td>
						<p>Área (m²) </p>
					</td>
					<td>
						<p>Comprimento ou largura (m) </p>
					</td>
				</tr>
			</thead>
			<tbody>
				<tr class="Row-Column-3">
					<td>
						<p>Abrigo para Auto, Caixas Eletrônicos </p>
					</td>
					<td>
						<p>não </p>
					</td>
					<td>
						<p>sim </p>
					</td>
					<td>
						<p>30</p>
					</td>
					<td>
						<p>–</p>
					</td>
				</tr>
				<tr class="Row-Column-3">
					<td>
						<p>Abrigo para Portão </p>
					</td>
					<td>
						<p>0,4</p>
					</td>
					<td>
						<p>sim </p>
					</td>
					<td>
						<p>–</p>
					</td>
					<td>
						<p>–</p>
					</td>
				</tr>
				<tr class="Row-Column-3">
					<td>
						<p>Abrigo de Porta </p>
					</td>
					<td>
						<p>não </p>
					</td>
					<td>
						<p>sim </p>
					</td>
					<td>
						<p>3</p>
					</td>
					<td>
						<p>comprimento de 2,00 m </p>
					</td>
				</tr>
				<tr class="Row-Column-3">
					<td>
						<p>Abrigo para Lixo <span class="notas">(2) (3)</span> </p>
					</td>
					<td>
						<p>não </p>
					</td>
					<td>
						<p>sim </p>
					</td>
					<td>
						<p>–</p>
					</td>
					<td>
						<p>–</p>
					</td>
				</tr>
				<tr class="Row-Column-3">
					<td>
						<p>Casa de Máquinas Isoladas <span class="notas">(2) </span></p>
					</td>
					<td>
						<p>não </p>
					</td>
					<td>
						<p>sim </p>
					</td>
					<td>
						<p>–</p>
					</td>
					<td>
						<p>–</p>
					</td>
				</tr>
				<tr class="Row-Column-3">
					<td>
						<p>Abrigo/Medidores de Concessionarias e Gás (Cilindros de GLP) <span class="notas">(2) </span></p>
					</td>
					<td>
						<p>não </p>
					</td>
					<td>
						<p>sim </p>
					</td>
					<td>
						<p>–</p>
					</td>
					<td>
						<p>–</p>
					</td>
				</tr>
				<tr class="Row-Column-3">
					<td>
						<p>Cabine de Força, Cabine Primária, Geradores, Pressurização, Centrais de Ar Condicionado Isoladas <span class="notas">(2) </span></p>
					</td>
					<td>
						<p>não </p>
					</td>
					<td>
						<p>sim </p>
					</td>
					<td>
						<p>–</p>
					</td>
					<td>
						<p>–</p>
					</td>
				</tr>
				<tr class="Row-Column-3">
					<td>
						<p>Caixas D’Água Elevadas Isoladas, Chaminés e Torres isoladas <span class="notas">(2) </span></p>
					</td>
					<td>
						<p>não </p>
					</td>
					<td>
						<p>não </p>
					</td>
					<td>
						<p>30</p>
					</td>
					<td>
						<p>–</p>
					</td>
				</tr>
				<tr class="Row-Column-3">
					<td>
						<p>Bilheteria </p>
					</td>
					<td>
						<p>não </p>
					</td>
					<td>
						<p>sim </p>
					</td>
					<td>
						<p>30</p>
					</td>
					<td>
						<p>–</p>
					</td>
				</tr>
				<tr class="Row-Column-3">
					<td>
						<p>Portaria </p>
					</td>
					<td>
						<p>não </p>
					</td>
					<td>
						<p>sim </p>
					</td>
					<td>
						<p>30</p>
					</td>
					<td>
						<p>–</p>
					</td>
				</tr>
				<tr class="Row-Column-3">
					<td>
						<p>Passagem coberta de pedestre sem vedação lateral </p>
					</td>
					<td>
						<p>não </p>
					</td>
					<td>
						<p>sim </p>
					</td>
					<td>
						<p>30</p>
					</td>
					<td>
						<p>largura de 3,00 m </p>
					</td>
				</tr>
			</tbody>
		</table>

		<h5 class="nota_quadro"><span class="notas">Notas:</span></h5>
		<h5 class="nota_quadro"><span class="notas">1.</span> Acima de 3,00 m (três metros) do nível do passeio.</h5>
		<h5 class="nota_quadro"><span class="notas">2.</span> As áreas construídas do abrigo de lixo, casas de máquinas, cabines de força, cabine primário, abrigos e medidores de gás, serão consideradas áreas técnicas mediante justificativa técnica decorrente de exigências das concessionarias.</h5>
		<h5 class="nota_quadro"><span class="notas">3.</span> Os depósitos de lixo, exceto para residências unifamiliares, deverão ter compartimentos fechados, com capacidade suficiente para armazenar vasilhames, coletores de lixo e lixo seletivo. Estes compartimentos deverão estar localizados no interior do lote ou da edificação e serem acessíveis ao logradouro, revestidos de material liso, impermeável, resistente a frequentes lavagens ser providos de ralo e prever pontos adequados para tal fim.</h5>

		<hr>

		<table id="table-2" class="quadro">
			<caption>Tabela 2 – Mobiliário</caption>
			<colgroup>
				<col class="Row-Column-4" />
				<col class="Row-Column-5" />
			</colgroup>
			<thead>
				<tr class="Row-Column-3">
					<td>
						<p>Mobiliário</p>
					</td>
					<td>
						<p>Dimensões máximas</p>
					</td>
				</tr>
			</thead>
			<tbody>
				<tr class="Row-Column-3">
					<td>
						<p>Guarita e módulo pré-fabricado </p>
					</td>
					<td>
						<p>15,00 m²</p>
					</td>
				</tr>
				<tr class="Row-Column-3">
					<td>
						<p>Abrigo ou telheiro sem vedação lateral em pelo menos 50% do perímetro</p>
					</td>
					<td>
						<p>5,00 m²</p>
					</td>
				</tr>
				<tr class="Row-Column-3">
					<td>
						<p>Estufas, quiosques e viveiros de plantas</p>
					</td>
					<td>
						<p>30,00 m²</p>
					</td>
				</tr>
				<tr class="Row-Column-3">
					<td>
						<p>Dutos de lareiras</p>
					</td>
					<td>
						<p>3,00 m²</p>
					</td>
				</tr>
				<tr class="Row-Column-3">
					<td>
						<p>Churrasqueiras</p>
					</td>
					<td>
						<p>30,00 m²</p>
					</td>
				</tr>
				<tr class="Row-Column-3">
					<td>
						<p>Pérgula</p>
					</td>
					<td>
						<p>área das nervuras: até 17% da área livre da edificação com relação mínima de 1:2 entre altura da nervura e parte vazada.</p>
					</td>
				</tr>
			</tbody>
		</table>

		<hr>

		<table id="table-3" class="quadro">
			<caption>Tabela 3 – Saliências</caption>
			<colgroup>
				<col class="Row-Column-6" />
				<col class="Row-Column-7" />
				<col class="Row-Column-7" />
				<col class="Row-Column-7" />
				<col class="Row-Column-7" />
			</colgroup>
			<thead>
				<tr class="Row-Column-3">
					<td rowspan="2">
						<p>Saliências </p>
					</td>
					<td colspan="3">
						<p>Poderão avançar sobre </p>
					</td>
					<td rowspan="2">
						<p>Dimensões máximas </p>
					</td>
				</tr>
				<tr class="Row-Column-3">
					<td>
						<p>Passeio Público <span class="notas">(1)</span></p>
					</td>
					<td>
						<p>Recuos LPUOS <span class="notas">(2)</span></p>
					</td>
					<td>
						<p>Das condições de aeração e insolação </p>
					</td>
				</tr>
			</thead>
			<tbody>
				<tr class="Row-Column-3">
					<td>
						<p>Aba Horizontal e Vertical, Brise, Viga, Pilar, Jardineira e Floreira, Ornato, Ornamento </p>
					</td>
					<td>
						<p>0,40 m </p>
					</td>
					<td>
						<p>até 10% </p>
					</td>
					<td>
						<p>–</p>
					</td>
					<td>
						<p>0,40 m </p>
					</td>
				</tr>
				<tr class="Row-Column-3">
					<td>
						<p>Beiral da Cobertura </p>
					</td>
					<td>
						<p>0,40 m </p>
					</td>
					<td>
						<p>até 50% </p>
					</td>
					<td>
						<p>até 10% </p>
					</td>
					<td>
						<p>1,50 m de largura </p>
					</td>
				</tr>
				<tr class="Row-Column-3">
					<td>
						<p>Marquise (não sobreposta) </p>
					</td>
					<td>
						<p>Até 50 % <span class="notas">(3) </span></p>
					</td>
					<td>
						<p>até 50% </p>
					</td>
					<td>
						<p>–</p>
					</td>
					<td>
						<p>30,00 m² </p>
					</td>
				</tr>
			</tbody>
		</table>
		<h5 class="nota_quadro"><span class="notas">Notas:</span></h5>
		<h5 class="nota_quadro"><span class="notas">1.</span> Acima de 3,00 m (três metros) do nível do passeio, não podendo interferir nas instalações públicas. </h5>
		<h5 class="nota_quadro"><span class="notas">2.</span> Estabelecidos pela LPUOS e não os adotados em projeto.</h5>
		<h5 class="nota_quadro"><span class="notas">3.</span> Não se aplica às ruas de pedestres ficando a critério da Prefeitura a análise caso a caso.</h5>

		<hr>

		<table id="table-4" class="quadro">
			<caption>Tabela 4 – Porcentagem máxima da área livre do terreno para construção de obras complementares e mobiliário</caption>
			<colgroup>
				<col class="Row-Column-4" />
				<col class="Row-Column-7" width="35%" />
			</colgroup>
			<thead>
				<tr class="Row-Column-3">
					<td>
						<p>Área do terreno</p>
					</td>
					<td>
						<p>% máxima da área livre do terreno <span class="notas">(1)</span></p>
					</td>
				</tr>
			</thead>
			<tbody>
				<tr class="Row-Column-8">
					<td>
						<p>Até 2.500,00 m²</p>
					</td>
					<td>
						<p>12%</p>
					</td>
				</tr>
				<tr class="Row-Column-8">
					<td>
						<p>o que exceder a 2.500,00 m² até 5.000,00 m²</p>
					</td>
					<td>
						<p>8%</p>
					</td>
				</tr>
				<tr class="Row-Column-8">
					<td>
						<p>o que exceder a 5.000,00 m² até 10.000,00 m²</p>
					</td>
					<td>
						<p>6%</p>
					</td>
				</tr>
				<tr class="Row-Column-8">
					<td>
						<p>o que exceder a 10.000,00 m²</p>
					</td>
					<td>
						<p>4%</p>
					</td>
				</tr>
			</tbody>
		</table>

		<h5 class="nota_quadro"><span class="notas">Nota 1:</span> Deverá ser observado o remanescente do imóvel quando o terreno for objeto de doação de área para alargamento de passeio ou por melhoramento público.</h5>
	</div>
</template>

<script>
export default{
	name: "Anexo4",
	data(){
		return{
			title: "Anexo 4",
			props:['caminho']
		}
	}
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Anexo4.vue